import { render } from "./ProductSearch.vue?vue&type=template&id=1113d581&scoped=true"
import script from "./ProductSearch.vue?vue&type=script&lang=js"
export * from "./ProductSearch.vue?vue&type=script&lang=js"

import "./ProductSearch.vue?vue&type=style&index=0&id=1113d581&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1113d581"]])

export default __exports__